import React from 'react';
export const CloseIcon = () => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--icon-color)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "m18.75 5.25-13.5 13.5m13.5 0L5.25 5.25"
}));